<div [froalaEditor]="options" [(froalaModel)]="content"></div>
